import { useState } from 'react';
import Image from 'next/image';
import InstitutionalPageImage from '@/assets/img/institutional-page-banner.svg';
import Logo from '@/assets/img/logo.svg';
import { InfoOutlined } from '@mui/icons-material';
import { Box, Button, Modal, Typography } from '@mui/material';
import CreateInstitutionalPage from '.';

interface InviteCreateInstitutionalPageProps {
  isOpen: boolean;
  handleClose: () => void;
}

const InviteCreateInstitutionalPage = ({
  isOpen,
  handleClose,
}: InviteCreateInstitutionalPageProps) => {
  const [isOpenCreateInstitutionalPage, setIsOpenCreateInstitutionalPage] =
    useState(false);

  const handleClickCreate = () => {
    setIsOpenCreateInstitutionalPage(true);
    handleClose();
  };

  return (
    <>
      <Modal
        aria-labelledby="modal-invite-create-institutional-page"
        aria-describedby="modal-invite-create-institutional-page-description"
        data-testid="modal-invite-create-institutional-page"
        open={isOpen}
        onClose={handleClose}
      >
        <Box
          sx={theme => ({
            padding: 2,
            background:
              'linear-gradient(167.13deg, #00A8F3 30.14%, #00D7D9 116.23%)',
            height: '100%',
            [theme.breakpoints.up('md')]: {
              width: '583px',
              height: 'min(600px, 100%)',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '4px',
            },
          })}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Box
              component="section"
              sx={{
                mt: 1,
                backgroundColor: 'warning.light',
                color: 'warning.dark',
                borderRadius: '8px',
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                width: 'calc(100% - 16px)',
              }}
            >
              <InfoOutlined
                sx={{
                  display: 'flex',
                  textAlign: 'right',
                }}
              />
              <Box sx={{ flex: '1', paddingRight: 'calc(40px - 16px)' }}>
                <Typography
                  variant="caption"
                  sx={{
                    mb: '4px',
                  }}
                >
                  Somente administradores e configuradores validados podem
                  gerenciar a página da empresa.
                </Typography>
              </Box>
            </Box>

            <Image src={Logo} alt="Logo do ObraPlay" width={228} height={80} />

            <Image
              src={InstitutionalPageImage}
              alt="Imagem ilustrando a página institucional da empresa"
              width={395}
              height={290}
            />

            <Box
              sx={{
                padding: 2,
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 2,
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                Minha página
              </Typography>

              <Typography variant="subtitle1" sx={{ width: '300px' }}>
                Crie uma página completa para sua empresa e utilize como quiser!
              </Typography>
            </Box>

            <Box
              sx={theme => ({
                justifySelf: 'justify-end',
                padding: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                width: '100%',
                [theme.breakpoints.up('md')]: {
                  flexDirection: 'row-reverse',
                },
              })}
            >
              <Button
                variant="outlined"
                sx={{ backgroundColor: 'background.paper' }}
                onClick={handleClickCreate}
                fullWidth
              >
                Criar agora
              </Button>

              <Button
                variant="outlined"
                sx={{
                  color: '#fff',
                  borderColor: '#FAFAFA',
                }}
                onClick={handleClose}
                fullWidth
              >
                Voltar
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <CreateInstitutionalPage
        isOpen={isOpenCreateInstitutionalPage}
        handleClose={() => setIsOpenCreateInstitutionalPage(false)}
      />
    </>
  );
};

export default InviteCreateInstitutionalPage;
